export const GetAllTailors_REQUEST = "GetAllTailors_REQUEST";
export const GetAllTailors_SUCCESS = "GetAllTailors_SUCCESS";
export const GetAllTailors_FAIL = "GetAllTailors_FAIL";

export const GetTailorsByID_REQUEST = "GetTailorsByID_REQUEST";
export const GetTailorsByID_SUCCESS = "GetTailorsByID_SUCCESS";
export const GetTailorsByID_FAIL = "GetTailorsByID_FAIL";

export const AddTailors_REQUEST = "AddTailors_REQUEST";
export const AddTailors_SUCCESS = "AddTailors_SUCCESS";
export const AddTailors_FAIL = "AddTailors_FAIL";

export const LoginTailor_REQUEST = "LoginTailor_REQUEST";
export const LoginTailor_SUCCESS = "LoginTailor_SUCCESS";
export const LoginTailor_FAIL = "LoginTailor_FAIL";

export const UpdateTailorDetails_REQUEST = "UpdateTailorDetails_REQUEST";
export const UpdateTailorDetails_SUCCESS = "UpdateTailorDetails_SUCCESS";
export const UpdateTailorDetails_FAIL = "UpdateTailorDetails_FAIL";
